class ShareToken {
  public node = 0;
  private callback: Function | null = null;
  private timerId: number | null = null;
  private LSKey = `oidc.user:${process.env.REACT_APP_AZURE_AUTHORITY}:${process.env.REACT_APP_AZURE_CLIENTID}`;
  public isInitialized = false;

  public init(callback: Function) {
    if (this.isInitialized) {
      return;
    }

    this.callback = callback;
    this.node = Date.now();
    const tabs = localStorage.getItem("tabs");
    const main = localStorage.getItem("main");
    if (tabs?.length) {
      const parsedTabs = JSON.parse(tabs);
      parsedTabs.push(this.node);
      if (!main || this.node >= parseFloat(main)) {
        localStorage.setItem("main", String(this.node));
      }
      localStorage.setItem("tabs", JSON.stringify(parsedTabs));
    } else {
      localStorage.setItem("tabs", JSON.stringify([this.node]));
      localStorage.setItem("main", String(this.node));
    }

    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener("storage", this.handleStorage);

    this.isInitialized = true;
  }

  private destroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    window.removeEventListener("storage", this.handleStorage);
    this.isInitialized = false;
    this.callback = null;
    this.node = 0;
    if (this.timerId) {
      window.clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  public get isMainNode() {
    const mainNode = localStorage.getItem("main");
    return !mainNode || String(this.node) === mainNode;
  }

  private handleStorage = (event: StorageEvent) => {
    if (event.key === "main") {
      console.log(`Main tab changed to ${event.newValue}`);
      const LSData = localStorage.getItem(this.LSKey);
      if (!LSData) {
        return;
      }
      const parsedLSData = JSON.parse(LSData);
      const interval = parsedLSData?.expires_at
        ? (parsedLSData?.expires_at - Date.now() / 1000 - 30) * 1000
        : 0;
      if (event.newValue === String(this.node)) {
        this.timerId = window.setTimeout(
          () => {
            this.callback?.();
          },
          interval < 30000 ? 0 : interval,
        );
      }
    }
  };

  private handleBeforeUnload = () => {
    const tabs = JSON.parse(localStorage.getItem("tabs") || "[]");
    const filteredTabs = tabs.filter((tab: number) => tab !== this.node);

    if (!filteredTabs.length) {
      localStorage.removeItem("main");
      localStorage.removeItem("tabs");
    } else {
      localStorage.setItem("tabs", JSON.stringify(filteredTabs));
      if (localStorage.getItem("main") === String(this.node)) {
        localStorage.setItem("main", String(Math.max(...filteredTabs)));
      }
    }

    this.destroy();
  };

  public cleanup() {
    localStorage.removeItem("main");
    localStorage.removeItem("tabs");
    this.destroy();
  }
}

export default new ShareToken();
